import React from "react";
import appStoreBadge from "../assets/images/app-store-badge.svg";
import googlePlayBadge from "../assets/images/google-play-badge.svg";

const APP_STORE_URL =
  "https://apps.apple.com/us/app/goal-guru-football-alerts/id6740241721";
const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.goalguru.app";

interface StoreBadgesProps {
  /** Badge height in px; both badges share the same aspect ratio. */
  height?: number;
  className?: string;
}

const StoreBadges: React.FC<StoreBadgesProps> = ({ height = 50, className }) => (
  <div className={`store-badges${className ? ` ${className}` : ""}`}>
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Download Goal Guru on the App Store"
    >
      <img src={appStoreBadge} alt="Download on the App Store" style={{ height }} />
    </a>
    <a
      href={GOOGLE_PLAY_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Get Goal Guru on Google Play"
    >
      <img src={googlePlayBadge} alt="Get it on Google Play" style={{ height }} />
    </a>
  </div>
);

export default StoreBadges;
